import type { Environment, Services } from '@/types'
import { z } from 'zod'

export const envUrlByService: Record<Services, Record<Environment, string>> = {
  'user-manager': {
    production: 'https://user-manager.alume.com',
    stage: 'https://user-manager-stage.alume.com',
    development: '',
  },
  'accounting-dealer': {
    production: 'https://accounting-dealer.alume.com',
    stage: 'https://accounting-dealer-stage.alume.com',
    development: '',
  },
}
export const clickSignWidgetUrl = {
  production: 'https://app.clicksign.com',
  stage: 'https://sandbox.clicksign.com',
  development: '',
  test: '',
}
const envSchema = z.object({
  MODE: z.enum(['production', 'stage', 'development', 'test']),
})

export const env = envSchema.parse(import.meta.env)
